import { httpClient, BaseService } from "@/app/old/desktop/shared/services/";
// import { BaseService } from "@/app/old/desktop/shared/services/";
import { terraBaseUrl } from "@/environment/environment";
const URL = "feature-types";

class API extends BaseService {
  constructor() {
    super(terraBaseUrl, URL);
  }
  async move(req) {
    return httpClient({
      url: `${terraBaseUrl}/feature-types/move/`,
      baseURL: this.baseURL,
      headers: req.headers,
      method: "post",
      data: req.body,
    }).then(res => res.data);
  }
}
export const featureTypeService = new API();
